import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { colorList } from '@/model/dataLayer/api/dish/Category'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import dayjs from 'dayjs'
import Dish from '@/model/dataLayer/api/dish/Dish'
import { saveFile } from '@/model/utils/utils'

const voucherType = 'membership/voucher/voucher-types'
const voucherPath = 'membership/voucher/'

const entity = {
  description: {
    header: false,
    formConfig: {
      required: false
    }
  },
  image: {
    header: false,
    type: IKDataEntity.Types.Image,
    tableConfig: {
      required: false
    }
  },
  imageDisplay: {
    displayName: 'image',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  name: {
  },
  color: {
    type: IKDataEntity.Types.Color,
    formConfig: {
      default: colorList[Math.round(Math.random() * 18)],
      required: false,
      hint: 'selected_color_will_be_used_in_orderDevice'
    },
    header: false,
    tableConfig: { filterable: false }
  },
  maxLimit: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  usageMinAmount: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  maxDiscountAmount: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  discountStr: {},
  productCodes: {
    header: false,
    type: IKDataEntity.Types.Option,
    formConfig: {
      default: [],
      required: false,
      type: {
        multiple: true,
        selectItems: async () => { return await Dish.getList(true) },
        itemText: 'dishName',
        itemValue: 'code'
      }
    }
  },
  activeSince: {
    header: false,
    type: IKDataEntity.Types.Date,
    formConfig: {
      default: dayjs().format('YYYY-MM-DD'),
      required: false
    }
  },
  activeSinceDisplay: {
    form: false
  },
  // activeSinceDate: {
  //   type: IKDataEntity.Types.Date,
  //   header: false
  // },
  // activeSinceTime: {
  //   type: IKDataEntity.Types.Time,
  //   header: false
  // },
  expiredAt: {
    header: false,
    type: IKDataEntity.Types.Date,
    formConfig: {
      required: false
    }
  },
  expiredAtDisplay: {
    form: false
  },
  note: {
    header: false,
    formConfig: {
      required: false
    }
  },
  // expiredAtDate: {
  //   type: IKDataEntity.Types.Date,
  //   formConfig: {
  //     require: false
  //   },
  //   header: false
  // },
  // expiredAtTime: {
  //   type: IKDataEntity.Types.Time,
  //   formConfig: {
  //     require: false
  //   },
  //   header: false
  // },
  active: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      required: false,
      default: true
    }
  },
  checkDetail: {
    displayName: 'detail',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function () {
    const res = (await hillo.get(cloudV2Url + voucherType + '/blId/' + GlobalConfig.blId)).map(it => {
      it.name = it.info.displayInfo.name
      it.description = it.info.displayInfo.description
      it.image = it.info.displayInfo.imageUrl
      it.color = it.info.displayInfo.color
      it.maxLimit = it.info.maxLimit
      it.usageMinAmount = it.info.usageMinAmount
      it.maxDiscountAmount = it.info.maxDiscountAmount
      it.discountStr = it.info.discountStr
      it.productCodes = it.info.productCodes
      it.activeSince = it.info.activeSince ? dayjs(it.info.activeSince).format('YYYY-MM-DD') : null
      it.expiredAt = it.info.expiredAt ? dayjs(it.info.expiredAt).format('YYYY-MM-DD') : null
      it.activeSinceDisplay = it.info.activeSince ? dayjs(it.info.activeSince).format('YYYY-MM-DD') : '-'
      it.expiredAtDisplay = it.info.expiredAt ? dayjs(it.info.expiredAt).format('YYYY-MM-DD') : '-'
      if (!it.note) {
        it.note = it.name + ' ' + it.description + ' ' + it.discountStr
      }
      // const [activeSinceDate, activeSinceTime] = it.info.activeSince.split('T')
      // it.activeSince = activeSinceDate + ' ' + activeSinceTime
      // it.activeSinceDate = activeSinceDate
      // it.activeSinceTime = activeSinceTime
      // const [expiredAtDate, expiredAtTime] = it.info.expiredAt.split('T')
      // it.expiredAt = expiredAtDate + ' ' + expiredAtTime
      // it.expiredAtDate = expiredAtDate
      // it.expiredAtTime = expiredAtTime
      return it
    })
    return res
  },
  add: async function (item) {
    item.blId = GlobalConfig.blId
    item.info = {
      displayInfo: {
        name: item.name,
        description: item.description,
        imageUrl: item.file ? await saveFile(item.file) : '',
        color: item.color
      },
      maxLimit: item.maxLimit,
      usageMinAmount: item.usageMinAmount,
      maxDiscountAmount: item.maxDiscountAmount,
      discountStr: item.discountStr,
      productCodes: item.productCodes.join(','),
      activeSince: item.activeSince ? item.activeSince + 'T00:00:00' : null,
      expiredAt: item.expiredAt ? item.expiredAt + 'T00:00:00' : null
      // activeSince: item.activeSinceDate + 'T' + item.activeSinceTime,
      // expiredAt: item.expiredAt + 'T' + item.expiredAtTime
    }
    item.note = item.name + ' ' + item.description + ' ' + item.discountStr
    item.voucherCodes = []
    return (await hillo.jsonPost(cloudV2Url + voucherType, {
      ...item
    })).content
  },
  edit: async function (item) {
    item.info = {
      displayInfo: {
        name: item.name,
        description: item.description,
        imageUrl: item.file ? await saveFile(item.file) : item.image,
        color: item.color
      },
      maxLimit: item.maxLimit,
      usageMinAmount: item.usageMinAmount,
      maxDiscountAmount: item.maxDiscountAmount,
      discountStr: item.discountStr,
      productCodes: item.productCodes.join(','),
      activeSince: item.activeSince ? item.activeSince + 'T00:00:00' : null,
      expiredAt: item.expiredAt ? item.expiredAt + 'T00:00:00' : null
      // activeSince: item.activeSinceDate + 'T' + item.activeSinceTime,
      // expiredAt: item.expiredAt + 'T' + item.expiredAtTime
    }
    return (await hillo.jsonPost(cloudV2Url + voucherType, {
      ...item
    })).content
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + voucherType + '/delete/' + id, {
      id
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getVoucherTypesList () {
  return (await hillo.get(cloudV2Url + voucherType + '/blId/' + GlobalConfig.blId)).map(it => {
    it.name = it.info.displayInfo.name
    it.description = it.info.displayInfo.description
    it.image = it.info.displayInfo.imageUrl
    it.color = it.info.displayInfo.color
    it.maxLimit = it.info.maxLimit
    it.usageMinAmount = it.info.usageMinAmount
    it.maxDiscountAmount = it.info.maxDiscountAmount
    it.discountStr = it.info.discountStr
    it.productCodes = it.info.productCodes
    it.activeSince = it.info.activeSince ? dayjs(it.info.activeSince).format('YYYY-MM-DD') : null
    it.expiredAt = it.info.expiredAt ? dayjs(it.info.expiredAt).format('YYYY-MM-DD') : null
    it.activeSinceDisplay = it.info.activeSince ? dayjs(it.info.activeSince).format('YYYY-MM-DD') : '-'
    it.expiredAtDisplay = it.info.expiredAt ? dayjs(it.info.expiredAt).format('YYYY-MM-DD') : '-'
    return it
  })
}

export async function distributeVoucherType (userId, voucherTypeId) {
  return (await hillo.jsonPost(cloudV2Url + voucherPath + 'voucher/distribute/' + userId + '/' + voucherTypeId, {}))
}

export async function getVoucherRecordByBlId () {
  return (await hillo.get(cloudV2Url + voucherPath + 'voucher-record/' + GlobalConfig.blId, {}))
}

export async function getAllVouchersForUserAndDevice (userId, deviceId) {
  return (await hillo.get(cloudV2Url + voucherPath + 'user/' + userId + '/device/' + deviceId))
}
